import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditAgent from "../../components/agents/FormAddEditAgent";
import { useNavigate } from "react-router-dom";

const EditAgent = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAgent
                isEdit={true}
                onSubmitSuccess={() => navigate("/agents")}
            />
        </WrapperSection>
    );
};

export default EditAgent;
